<template>
  <div :id="widgetId" class="productTrusmateStars"></div>
</template>

<script>
export default {
  name: 'ProductTrusmateStars',
  props: {
    product: {
      type: Number,
      required: true,
    },
  },
  computed: {
    widgetId() {
      return '84b2b776-b0bb-4a88-9c19-132f71306d1f';
    },
    scriptId() {
      return `trustmate-script-${1000753}-${this.product}`;
    },
  },
  mounted() {
    this.$helper.loadScript(
      `https://trustmate.io/widget/api/84b2b776-b0bb-4a88-9c19-132f71306d1f/script?product=${1000753}-${
        this.product
      }`,
      this.scriptId,
    );
  },
  destroyed() {
    this.$helper.removeScriptById(this.scriptId);

    const el = document.querySelector('.tm-hornet-container-slide');
    if (el) {
      el.remove();
    }
  },
};
</script>

<style scoped lang="scss">
.productTrusmateStars {
  margin-bottom: 0.5rem;
  height: 25px;
}
</style>
